import { render, staticRenderFns } from "./ReporteNovedadesHSEMapa.vue?vue&type=template&id=49f25c10"
import script from "./ReporteNovedadesHSEMapa.vue?vue&type=script&lang=js"
export * from "./ReporteNovedadesHSEMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports